/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

export default function Play({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="99"
      height="98"
      viewBox="0 0 99 98"
      fill="none"
      css={{
        ...css`
          cursor: pointer;
        `,
        ...(props.css ? props.css : {}),
      }}
      {...props}
    >
      <ellipse
        opacity="0.95"
        cx="49.5"
        cy="49.0741"
        rx="39.5"
        ry="39.2007"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        opacity="0.95"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.1567 35.8981C41.1578 35.1124 42.0229 34.6348 42.6884 35.0525L63.2702 47.972C63.8943 48.3637 63.8948 49.2728 63.2713 49.6653L42.654 62.641C41.9876 63.0605 41.1203 62.5808 41.1214 61.7933L41.1567 35.8981Z"
        fill="currentColor"
      />
    </svg>
  );
}

Play.propTypes = {
  css: PropTypes.instanceOf(css),
};
